export enum PlanningDepartmentRequestType {
  ExtractFromLocalSpatialDevelopmentPlan = 'extract-from-local-spatial-development-plan',
  ExtractFromStudy = 'extract-from-study',
  Certificate = 'certificate-from-local-spatial-development-plan'
}
